var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBluegift(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.72835C7.64918 3.08734 7.25611 2.50957 6.89183 2.2894C5.90607 1.69364 4.64559 2.04719 4.07646 3.07909C3.73443 3.69924 3.71994 4.42326 3.9768 5.03164C2.87435 5.09454 2 5.99614 2 7.09914C2 7.66343 2.22884 8.17501 2.6 8.54854H7.52V5.02813H8.48V8.54854H13.4C13.7712 8.17501 14 7.66343 14 7.09914C14 5.99614 13.1257 5.09454 12.0232 5.03164C12.2801 4.42327 12.2656 3.69925 11.9235 3.0791C11.3544 2.04721 10.0939 1.69365 9.10817 2.28942C8.74389 2.50958 8.35083 3.08735 8 3.72835ZM8.48 5.02813L8.59408 4.91688C8.79484 4.49951 9.01312 4.08969 9.22713 3.76106C9.3338 3.59725 9.4299 3.46839 9.51226 3.37446C9.58886 3.2871 9.63205 3.25485 9.63814 3.25032C10.1169 2.96095 10.7292 3.13267 11.0056 3.63388C11.2707 4.11451 11.1302 4.72375 10.6961 5.02813H8.48ZM7.52 5.02813H5.3037C4.86934 4.72382 4.72926 4.11459 4.9944 3.63386C5.27083 3.13266 5.88306 2.96093 6.36186 3.2503C6.36795 3.25484 6.41114 3.28708 6.48774 3.37444C6.5701 3.46838 6.6662 3.59723 6.77287 3.76104C6.98688 4.08968 7.20516 4.49949 7.40592 4.91687L7.52 5.02813Z",
    fill: "url(#paint0_linear_7525_24655)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6 11.3373C2.6 12.8079 3.80883 14 5.3 14H7.52V9.45561H2.6V11.3373Z",
    fill: "url(#paint1_linear_7525_24655)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7 14C12.1912 14 13.4 12.8079 13.4 11.3373V9.45561H8.48V14H10.7Z",
    fill: "url(#paint2_linear_7525_24655)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7525_24655",
    x1: 2,
    y1: 2.28662,
    x2: 13.8959,
    y2: 14.5051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15CCCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492409,
    stopColor: "#4987FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B1CFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7525_24655",
    x1: 2,
    y1: 2.28662,
    x2: 13.8959,
    y2: 14.5051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15CCCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492409,
    stopColor: "#4987FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B1CFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7525_24655",
    x1: 2,
    y1: 2.28662,
    x2: 13.8959,
    y2: 14.5051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15CCCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492409,
    stopColor: "#4987FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B1CFA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluegift);
export default __webpack_public_path__ + "static/media/blue.gift.b580a13c3e2a611451cbd93b5d28fa0b.svg";
export { ForwardRef as ReactComponent };